import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import { PrismicLinkTag } from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import TextOnlyContainer from "@sendmagic/prismic-nextjs/src/components/TextOnlyContainer";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const CurvedBlockTextWithImage = ({ doc }) => {
  const {
    heading,
    description,
    image,
    internal_link_id,
    link,
    link_text,
    background_color,
    image_in_right,
    border_color,
  } = doc?.primary || {};

  const sectionStyle = {
    backgroundColor: background_color || "",
    border: `1px solid ${border_color || "transparent"}`,
  };

  const renderCurvedBlockImage = () => (
    <div className="curved-block-image-section">
      <PrismicImgix
        alt={image?.alt}
        src={image?.url}
        className="textModule2 w-100 curved-block-image"
        desktop="370px"
        mobile="375px"
        tablet="400px"
        largeDisplay="700px"
      />
    </div>
  );

  return (
    <div
      className={`p-md-5 curved-block-text-slice prismic-slice ${
        border_color ? "bordered-version" : ""
      }`}
      style={sectionStyle}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-absolute d-block" />
      )}
      <div className="container container-width curved-block-text-slice-container">
        <div className="d-flex flex-wrap justify-content-between curved-block-content-blocks-row">
          {!image_in_right && renderCurvedBlockImage()}
          <div className="curved-block-content-section">
            {checkContentPresence(heading) && (
              <TextOnlyContainer text={heading} classes="sns-h2 curved-block-text-title" />
            )}
            {checkContentPresence(description) && (
              <TextOnlyContainer text={description} classes="mt-3 curved-block-text-description" />
            )}
            {link?.url && checkContentPresence(link_text) && (
              <div className="mt-4 curved-block-image-content-link-row">
                <span>
                  <PrismicLinkTag
                    urlText={link_text}
                    url={link?.url}
                    target={link?.target}
                    className="curved-block-image-content-link"
                  />
                </span>
              </div>
            )}
          </div>
          {image_in_right && renderCurvedBlockImage()}
        </div>
      </div>
    </div>
  );
};

export default CurvedBlockTextWithImage;
